<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVA','ATTIVITÀ'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="attivita_lead">
            <vs-row>
            <!-- <vs-row v-if="this.$route.params"> -->
              <vs-col v-if="!externalSource" class="md:w-12/12 w-full px-2">
                <label class="vs-input--label">Sceglie il tipo:</label>
              </vs-col>
              <vs-col v-if="!externalSource" class="md:w-12/12 w-full px-2">
                <!-- <v-radio-group v-model="radio_ca">
                  <v-radio class="mx-2" :disabled="readonly" name="radio_ca" label="Azienda" :value="'az'"></v-radio>
                  <v-radio class="mx-2" :disabled="readonly" name="radio_ca" label="Contatto" :value="'con'"></v-radio>
                  <v-radio class="mx-2" :disabled="readonly" name="radio_ca" label="Lead" :value="'lea'"></v-radio>
                  <v-radio class="mx-2" :disabled="readonly" name="radio_ca" label="Altro" :value="'more'"></v-radio>
                </v-radio-group> -->
                <vs-radio class="mx-2" :disabled="readonly" v-model="radio_ca" vs-value="az">Azienda</vs-radio>
                <vs-radio class="mx-2" :disabled="readonly" v-model="radio_ca" vs-value="con">Contatto</vs-radio>
                <vs-radio class="mx-2" :disabled="readonly" v-model="radio_ca" vs-value="lea">Lead</vs-radio>
                <vs-radio class="mx-2" :disabled="readonly" v-model="radio_ca" vs-value="more">Altro</vs-radio>
              </vs-col>
              <vs-col class="md:w-12/12 w-full px-2">
                <vs-col v-if="radio_ca == 'az'" :key="formkey">
                  <label class="vs-input--label">Azienda</label>
                  <v-select :disabled="readonly || externalSource" class="w-full" name="azienda" placeholder="Scrivi l'azienda da cercare..." :options="aziende" @search="fetchAziende" v-model="azienda" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('attivita_lead.azienda')">{{ errors.first('attivita_lead.azienda') }}</span>
                </vs-col>
                <vs-col v-if="radio_ca == 'con'" :key="formkey">
                  <label class="vs-input--label">Contatto</label>
                  <v-select :disabled="readonly || externalSource" class="w-full" name="contatto" placeholder="Scrivi il contatto da cercare..." :options="contatti" @search="fetchContatti" v-model="contatto" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('attivita_lead.contatto')">{{ errors.first('attivita_lead.contatto') }}</span>
                </vs-col>
                <vs-col v-if="radio_ca == 'lea'" :key="formkey">
                  <label class="vs-input--label">Lead</label>
                  <v-select :disabled="readonly || externalSource" class="w-full" name="lead" placeholder="Scrivi il lead da cercare..." :options="leads" v-model="lead" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('attivita_lead.lead')">{{ errors.first('attivita_lead.lead') }}</span>
                </vs-col>
              </vs-col>
            </vs-row>
            <vs-row>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col class="w-full px-2 mt-4">
                <label class="text-sm">Tipo Attività</label>
                <v-select :disabled="(readonly || (this.$route.params && this.$route.params.tir_mail) ? true : false)" @option:created="formatOpt" taggable push-tags name="tipo" placeholder="Scegli l'attività da compiere" :options="tipo_list" v-model="tipo" v-validate="'required'" ><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm" v-show="errors.has('attivita_lead.tipo')">{{ errors.first('attivita_lead.tipo') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-4" :key="tipokey+2">
                <label class="text-sm">Data di scadenza</label>
                <datepicker :typeable="true" :disabled="readonly" placeholder="Seleziona la data di scadenza" :language="languages['it']" :format="datepicker_format" name="data_scadenza" v-validate="'required'" v-model="data_scadenza">
                <span v-if="data_scadenza" slot="afterDateInput" class="animated-placeholder">
                  <vs-button @click="clearDateScad($event)" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="w-full"></vs-button>
                </span>
                </datepicker>
                <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.data_scadenza')">{{ errors.first('attivita_lead.data_scadenza') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-4" :key="tipokey+3">
                <label class="text-sm">Data di completamento</label>
                <datepicker :typeable="true" :disabled="readonly" placeholder="Seleziona la data di completamento" :language="languages['it']" :format="datepicker_format" name="data_completamento" v-model="data_completamento">
                  <span v-if="data_completamento" slot="afterDateInput" class="animated-placeholder">
                    <vs-button @click="clearDate($event)" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="w-full"></vs-button>
                  </span>
                </datepicker>
                <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.data_completamento')">{{ errors.first('attivita_lead.data_completamento') }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col v-if="this.tipo != 'Mail'" class="vx-col w-full">
                <div v-if="this.tipo == 'Appuntamento'" class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="BriefcaseIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none"> Gestisci il tuo Appuntamento</span>
                </div>
                <div v-if="this.tipo == 'Tirocinio'" class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="AwardIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none"> Gestisci il tuo Tirocinante</span>
                </div>
                <vs-divider />
                <div v-if="this.tipo == 'Appuntamento' || this.tipo == 'Tirocinio' || this.tipo == 'Altro'" class="flex items-end px-3 mt-4">
                  <vs-col class="md:w-1/3 w-full px-2">
                    <vs-input :disabled="readonly" label="Ora inizio" class="w-full" v-model="appuntamento_orario" type="time" min="07:00" max="20:00" step="900"/>
                    <!-- <vue-timepicker typeable :disabled="readonly" v-model="appuntamento_orario" hide-disabled-hours :hour-range="[[7,20]]" :minute-interval="15"></vue-timepicker> -->
                  </vs-col>
                  <vs-col class="md:w-1/3 w-full px-2">
                    <vs-input :disabled="readonly" label="Ora fine" class="w-full" v-model="appuntamento_orario_fine" type="time" min="07:00" max="20:00" step="900"/>
                    <!-- <vue-timepicker typeable :disabled="readonly" v-model="appuntamento_orario_fine" hide-disabled-hours :hour-range="[[7,20]]" :minute-interval="15"></vue-timepicker> -->
                  </vs-col>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col v-if="this.tipo == 'Mail'" class="w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="MailIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Inserisici i dati della Mail</span>
                </div>
                <vs-divider />
                <vs-col class="md:w-1/2 w-full px-2" :key="tipokey+4">
                  <label class="vs-input--label">Mittente</label>
                  <vs-input :disabled="readonly" v-model="mittente" class="w-full" name="mittente" placeholder="Inserisci la mail da cui hai ricevuto la mail" v-validate="'required|email'" />
                  <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.mittente')">{{ errors.first('attivita_lead.mittente') }}</span>
                </vs-col>
                <vs-col class="md:w-1/2 w-full px-2" >
                  <label class="vs-input--label">Destinatario</label>
                  <vs-input :disabled="readonly" v-model="destinatario" class="w-full" name="destinatario" placeholder="Inserisci la mail a chi hai inviato la mail" v-validate="'required|email'" />
                  <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.destinatario')">{{ errors.first('attivita_lead.destinatario') }}</span>
                </vs-col>
                <vs-col class="w-full px-2">
                  <label class="vs-input--label">Mail</label>
                  <vs-textarea :disabled="readonly" v-model="descrizione" placeholder="Inserisci il contenuto della mail" name="descrizione" v-validate="'required'" :key="tipokey+11"/>
                  <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.descrizione')">{{ errors.first('attivita_lead.descrizione') }}</span>
                </vs-col>
              </vs-col>
              <vs-col v-if="this.tipo == 'Telefonata'" class="w-full px-2 mt-6">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="PhoneCallIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Gestisci la tua attività per telefono</span>
                </div>
                <vs-divider />
                <vs-col class="px-2 w-full" :key="tipokey+5">
                  <label class="text-sm">Origine Telefonata</label>
                  <v-select :disabled="readonly" name="direzione_chiamata" placeholder="Scegli l'origine della telefonata" :options="direzione_chiamata_list"  v-model="direzione_chiamata" v-validate="'required'" ><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('attivita_lead.direzione_chiamata')">{{ errors.first('attivita_lead.direzione_chiamata') }}</span>
                </vs-col>
              </vs-col>
              <vs-col v-if="this.tipo" class="px-2 w-full">
                <vs-col>
                <label class="text-sm">Descrivi l'attività</label>
                <vs-textarea height="120px" :disabled="readonly" v-model="descrizione" placeholder="Scrivi i dettagli dell'attività da svolgere o terminata" name="descrizione" v-validate="'required'" :key="tipokey+1"/>
                <span class="text-danger text-sm"  v-show="errors.has('attivita_lead.descrizione')">{{ errors.first('attivita_lead.descrizione') }}</span>
              </vs-col>
              </vs-col>
              <vs-col class="px-2 w-full mt-6 white_back">
                <div class="flex items-end px-3 my-4">
                  <feather-icon svgClasses="w-6 h-6" icon="CalendarIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">{{[altre_attivita.length ? '' : 'non ci sono ','ultime Attività'].join('')}}</span>
                </div>
                <vs-table v-if="altre_attivita.length" :pagination="altre_attivita.length > 5" :max-items="5" :data="altre_attivita">
                  <template slot="thead">
                      <vs-th>Attività</vs-th>
                      <vs-th>Tipo</vs-th>
                      <vs-th>Responsabile</vs-th>
                      <vs-th>Stato</vs-th>
                      <vs-th>Data Completamento</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr class="row-no-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="tr.nome">
                        {{tr.nome}}
                      </vs-td>

                      <vs-td :data="tr.tipo">
                        <vx-tooltip :text="tr.tipo" position="left" class="tr-tooltip">
                          <vs-button v-if="tr.tipo == 'Appuntamento'" disabled type="line" icon-pack="feather" icon="icon-bell"></vs-button>
                          <vs-button v-if="tr.tipo == 'Telefonata'" disabled type="line" icon-pack="feather" icon="icon-phone"></vs-button>
                          <vs-button v-if="tr.tipo == 'Mail'" disabled type="line" icon-pack="feather" icon="icon-mail"></vs-button>
                          <vs-button v-if="tr.tipo == 'Altro'" disabled type="line" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="tr.responsabile">
                        {{[tr.responsabile.cognome,tr.responsabile.nome].join(' ')}}
                      </vs-td>

                      <vs-td :data="[tr.data_scadenza,tr.data_completamento]">
                        <vx-tooltip v-if="tr.data_scadenza < new Date() && !tr.data_completamento" text="Scaduto" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-zap-off"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-else-if="tr.data_completamento" text="Completato" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-check"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-else text="Aperta" position="left" class="tr-tooltip">
                          <vs-button disabled type="flat" icon-pack="feather" icon="icon-watch"></vs-button>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="tr.data_completamento">
                        {{tr.data_completamento ? formatDate(new Date(tr.data_completamento)) : ''}}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <vs-divider />
              </vs-col>
            </vs-row>
          </form>
        </div>
          <vs-row slot="footer" class="mb-3 mt-3">
            <vs-divider />
            <vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
              <vs-button v-if="this.id" @click="eliminaAttivitaLead($event)" icon-pack="feather" icon="icon-trash" color="danger" type="line" align="right">Elimina</vs-button>
              <vs-button :disabled="readonly" @click="salvaAttivitaLead($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
            </vs-col>
          </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';
import VueTimepicker from 'vue2-timepicker'

// For custom error message
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {
      required: 'Nome è un campo obbligatorio'
    },
    responsabile: {
      required: 'Contatto è un campo obbligatorio',
    },
    contatto: {
      required: 'Contatto è un campo obbligatorio',
    },
    lead: {
      required: 'Lead è un campo obbligatorio',
    },
    azienda: {
      required: 'Azienda è un campo obbligatorio',
    },
    tipo: {
      required: 'Tipo è un campo obbligatorio',
    },
    data_scadenza: {
      required: 'Inserire una data',
      date_format: 'La data deve essere nel formato d MMM yyyy'
    },
    data_completamento: {
      date_format: 'La data deve essere nel formato d MMM yyyy'
    },
    descrizione: {
      required: 'Descrizione è un campo obbligatorio',
    },
    direzione_chiamata: {
      required: 'Selezionare una direzione'
    },
    mittente: {
      required: 'Compilare questo campo',
      email: 'Deve essere un indirizzo email valido'
    },
    destinatario: {
      required: 'Compilare questo campo',
      email: 'Deve essere un indirizzo email valido'
    }

  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      id: null,
      nome: "Attività",
      descrizione: "",
      tipo: "",
      data_scadenza: "",
      data_completamento: "",
      nome_creatore: "",

      responsabile: null,
      responsabili: [],

      lead: null,
      leads: [],

      azienda: null,
      aziende: [],

      contatto: null,
      contatti: [],

      direzione_chiamata: null,
      direzione_chiamata_list: ['Ingresso', 'Uscita'],

      mittente: null,
      destinatario: null,

      radio_ca: 'more',

      tipo_list: [],
      // tipo_list: ['Telefonata', 'Mail', 'Appuntamento', 'Altro'].map(e => { return {label: e} }),

      datepicker_format: "d.MM.yyyy",
      languages: lang,

      formkey: null,
      tipokey: null,

      appuntamento_orario: null,
      appuntamento_orario_fine: null,
      readonly: false,
      externalSource: false,
    }
  },

  props: {
    selected: Object,
    tirocinio: Object,
    selected_date: Date,
    customer: Object,
    id_lead: Number,
    text: String,
    stato_lead: Object,
    altre_attivita: Array,
    id_az: Object,
    id_cont: Object,
  },
  components: {
    vSelect,
    Datepicker,
    VueTimepicker,
  },
  beforeMount() {
    this.azienda = null
    if (this.$route.params && this.$route.params.az_id) {
      this.externalSource = true
      this.radio_ca = 'az'
      this.azienda = this.$route.params.az_id
    }
    if (this.$route.params && this.$route.params.type) {
      // TIROCINIO
      this.externalSource = true
      this.radio_ca = 'az'
      this.azienda = this.$route.params.azienda
      this.tipo = this.$route.params.type
      this.descrizione = 'L\'incontro si terrà presso gli uffici di Iscom Bologna situati in Strada Maggiore, 23 Bologna'
    }
    this.contatto = null
    if (this.$route.params && this.$route.params.cont_id) {
      this.externalSource = true
      this.radio_ca = 'con'
      this.contatto = this.$route.params.cont_id
    }
    this.lead = null
    if (this.$route.params && this.$route.params.lead_id) {
      this.externalSource = true
      this.radio_ca = 'lea'
      this.lead = this.$route.params.lead_id
    }
    this.getUtenti()
    this.getTipoAtt()
    if (this.selected_date) {
      this.data_scadenza = this.selected_date
    }
    if (!this.id_lead) {
      this.getLeads()
    } else {
      this.lead = null
      this.externalSource = true
      this.radio_ca = 'lea'
      this.externalSource = true
      this.lead = { label: this.text }
    }
    this.formkey = Math.random()
    this.tipokey = Math.random()
    if (this.selected) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      if(this.azienda) {
        this.azienda = this.selected.azienda
        this.azienda['label'] = `${this.azienda['ragione_sociale']} - ${this.azienda['codice_fiscale']}`
        this.radio_ca = 'az'
      }
      if(this.contatto) {
        this.contatto = this.selected.contatto
        this.contatto['label'] = `${this.contatto['nome']} ${this.contatto['cognome']}`
        this.radio_ca = 'con'
      }
      if(this.lead) {
        this.lead['label'] = `${this.lead['nome']}`
        this.radio_ca = 'lea'
      }
      if(this.creatore) {
        this.nome_creatore = this.creatore['nome']
      }
      if(this.responsabile) {
        this.responsabile['label'] = this.responsabile['nome']
      }
      if(this.orario_hh) {
        this.appuntamento_orario = this.orario_hh
      }
      if(this.orario_fine_hh) {
        this.appuntamento_orario_fine = this.orario_fine_hh
      }
    }
    else {
      this.nome_creatore = localStorage.utente_nome
    }
    if (localStorage.utente_nome) {
      this.utente_nome = localStorage.utente_nome
    }
    if (localStorage.utente_id) {
      this.utente_id = localStorage.utente_id
    }
  },

  methods: {
    formatOpt(opt) {
      opt.label = opt.label.charAt(0).toUpperCase() + opt.label.slice(1)
    },
    clearDate(ev) {
      this.data_completamento = ""
      ev.stopPropagation()
    },

    clearDateScad(ev) {
      this.data_scadenza = ""
      ev.stopPropagation()
    },
    getTipoAtt() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/board/tipi_attivita',{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(e => {
        e.data.forEach( el => {
          this.tipo_list.push(el.tipo)
        })
        if (e.data.filter(el => el.tipo === 'Altro').length == 0) {
          // e.data.push({tipo: 'Altro'})
          this.tipo_list.push('Altro')
        }
        if (e.data.filter(el => el.tipo === 'Appuntamento').length == 0) {
          // e.data.push({tipo: 'Appuntamento'})
          this.tipo_list.push('Appuntamento')
        }
        if (e.data.filter(el => el.tipo === 'Telefonata').length == 0) {
          // e.data.push({tipo: 'Telefonata'})
          this.tipo_list.push('Telefonata')
        }
        if (e.data.filter(el => el.tipo === 'Mail').length == 0) {
          // e.data.push({tipo: 'Mail'})
          this.tipo_list.push('Mail')
        }
        if (e.data.filter(el => el.tipo === 'Door to Door').length == 0) {
          // e.data.push({tipo: 'Mail'})
          this.tipo_list.push('Door to Door')
        }
        if (e.data.filter(el => el.tipo === 'Impegno personale').length == 0) {
          // e.data.push({tipo: 'Mail'})
          this.tipo_list.push('Impegno personale')
        }
      }).catch(e => console.log(e))
    },
    fetchAziende(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)

      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.contatto = null
        this.contatti = []
        this.aziende = e.data.map(e => {
          e['label'] = `${e['ragione_sociale']} - ${e['codice_fiscale']}`
          return e
        })
        loading(false)
      })
    },
    fetchContatti(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)

      axios.post(process.env.VUE_APP_BACKEND_API+'/contatto/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.aziende = []
        this.azienda = null
        this.contatti = e.data.map(e => {
          e['label'] = `${e['nome']} ${e['cognome']}`
          return e
        })
        loading(false)
      })
    },
    getUtenti() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/utente/trova', {
        pag: 1,
        keyword: '',
        take: 50
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then(e => {
        this.responsabili = e.data.res.map(e => {
          e['label'] = `${e['nome']}`+' '+`${e['cognome']}`
          return e
        })
      }).catch(e => console.log(e))
    },
    getLeads() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/many_leads', {
        option: "Tutti",
        keyword: "",
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(response => { this.leads = response.data.map( l => {l['label'] = [l.nome,l.azienda ? l.azienda.ragione_sociale : [l.contatto.cognome,l.contatto.nome].join(' ')].join(' - ')
                                                                  return l}) }).catch(e => {console.log(e)})
    },
    buildSaveObject() {
      let obj = {
        nome: this.nome,
        descrizione: this.descrizione,
        // tipo: this.tipo.label,
        tipo: this.tipo,
        data_scadenza: this.data_scadenza ? this.data_scadenza : null,
        data_completamento: this.data_completamento ? this.data_completamento : null,
        id_responsabile: this.responsabile ? this.responsabile.id : +localStorage.utente_id,
        mittente: this.tipo == 'Mail' ? this.mittente : null,
        destinatario: this.tipo == 'Mail' ? this.destinatario : null,
        direzione_chiamata: this.tipo == 'Telefonata' ? this.direzione_chiamata : null
      }
      // console.log(this.data_scadenza);
      let x = new Date(this.data_scadenza)
      // x.setDate(x.getDate() + 1)
      x.setHours(24)
      x.setHours(-10)
      obj.data_scadenza = x
      x = new Date(this.data_completamento)
      // x.setDate(x.getDate() + 1)
      x.setHours(24)
      x.setHours(-10)
      obj.data_completamento = x
      // console.log(obj.data_scadenza);

      if (this.tipo == 'Appuntamento' || this.tipo == 'Tirocinio' || this.tipo == 'Altro') {
        obj['orario_hh'] = this.appuntamento_orario ? this.appuntamento_orario : ''
        // obj['orario_mm'] = this.appuntamento_orario ? this.appuntamento_orario : null
        obj['orario_fine_hh'] = this.appuntamento_orario_fine ? this.appuntamento_orario_fine : ''
        // obj['orario_fine_mm'] = this.appuntamento_orario_fine ? this.appuntamento_orario_fine : null
      }
      if (this.id_lead || this.lead) {
        obj['id_lead'] = this.id_lead ? this.id_lead : this.lead.id
        obj['id_contatto'] = this.contatto ? this.contatto.id : null
        obj['id_azienda'] = this.azienda ? this.azienda.id : null
      } else if (this.azienda || (this.customer && this.customer['ragione_sociale'])) {
        obj['id_azienda'] = this.azienda.id
      } else if (this.contatto || (this.customer && this.customer['cognome'])){
        obj['id_contatto'] = this.contatto.id
      }
      if (this.id) {
        obj['id'] = this.id
      }
      if (this.$route.params && this.$route.params.tir_mail) {
        obj['descrizione_add'] = this.$route.params.tiroc_fullname
        obj['tir_email'] = this.$route.params.tir_mail
        obj['tir_message'] = ['Gentile Tirocinante,\n',
                              'le comunichiamo che le è stato fissato un appuntamento.',
                              `dalle ${this.appuntamento_orario ? this.appuntamento_orario : ''} alle ${this.appuntamento_orario_fine ? this.appuntamento_orario_fine : ''}`,
                              `in data: ${this.$tariffe.formatDateNew(this.data_scadenza)}`,
                              `Descrizione: ${this.descrizione}`
                              ].join("\n")
      }
      return obj
    },
    checkLeadActivities(att_list) {
      if (att_list && att_list.length) {
        let completed = []
        att_list.forEach( att => {
          if (att.data_completamento) completed.push(att)
        })
        if (completed.length == att_list.length) return true
        else return false
      } else {
        return true
      }
    },
    salvaAttivitaLead(ev) {
      this.validateAttivitaLead().then(() => {
        axios.post(process.env.VUE_APP_BACKEND_API+'/board/attivita_lead/' + (this.id ? 'modifica' : 'crea'), this.buildSaveObject(), {
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true
        }).then(() => {
          if (this.id_lead || (this.lead && this.lead.id)) {
            axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/get_one', { id: this.id_lead ? this.id_lead : this.lead.id }, {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true
            })
            .then( res => {
              let activities_completed = this.checkLeadActivities(res.data.attivita_leads)
              if (res.data.stato.nome == 'Qualifica' && activities_completed) {
                axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/modifica', { id: this.id_lead ? this.id_lead : this.lead.id, id_stato: res.data.stato.id_destro }, {
                  headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                  withCredentials: true
                })
                .then( () => {
                  this.$vs.notify({
                    color: 'warning',
                    time: 4000,
                    title: ['Lead -',res.data.nome,'passato di stato'].join(' '),
                    text: ['Passato a','In corso di decisione'].join(' - ')
                  })
                  this.$emit('attivita-lead-salvato')
                  ev.stopPropagation()
                }).catch(e => console.error(e))
              } else if (res.data.stato.nome == 'In corso di decisione' && activities_completed) {
                axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/modifica', { id: this.id_lead ? this.id_lead : this.lead.id, id_stato: res.data.stato.id_destro }, {
                  headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                  withCredentials: true
                })
                .then( () => {
                  this.$vs.notify({
                    color: 'warning',
                    time: 4000,
                    title: ['Lead -',res.data.nome,'passato di stato'].join(' '),
                    text: ['Passato a','Passaggio alle vendite'].join(' - ')
                  })
                  this.$emit('attivita-lead-salvato')
                  ev.stopPropagation()
                }).catch(e => console.error(e))
              } else {
                this.$emit('attivita-lead-salvato')
              }
            }).catch(e => console.error(e))
          } else {
            this.$emit('attivita-lead-salvato')
            ev.stopPropagation()
          }
        }).catch(e => console.log(e))
      })
    },
    validateAttivitaLead() {
      // console.log('VALIDATE ATTIVITA LEAD');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('attivita_lead').then(result => {
          if (result) {
            // console.log('success');
            resolve(true)
          } else {
            // console.log('failed', this.$validator);
            reject("correct all values");
          }
        })
      })
    },
    eliminaAttivitaLead(ev) {
      this.$emit('elimina-attivita-lead', this.id)
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    formatDate(date) {
      var options = { year: "numeric", month: "short", day: "numeric" }
      return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
    },
  },

  watch: {
    radio_ca() {
      this.formkey = Math.random()
    },
    tipo() {
      this.tipokey = Math.random()
    },
  },

  computed: {
    canEdit: {
      get() {
        return !this.id || +this.utente_id === +this.creatore.id || (this.amministratore && +this.utente_id === +this.amministratore.id) || this.$acl.check('admin')
      },
    },
    // radio_ca: {
    //   get() {return this.radio_ca},
    //   set(v) { if (!v) this.radio_ca = null
    //           else this.radio_ca = v}
    // }
  }
}
</script>
